import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { userActions } from '../../../store/slices/userSlice';
import { toast } from 'react-hot-toast';
import {
  IMAGES_ASSESTS_PATH,
  errorToast,
  successToast,
} from '../../../constants';
import SpinnerLoader from '../../common/spinner/Spinner';

function ForgotPassword() {
  const [showSpinner, setSpinner] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    dispatch(userActions.forgotPasswordRequest(data));
  };

  useEffect(() => {
    setSpinner(user.loading);
    user.error && toast.error(user.error, errorToast);
    if (user.user?.message) {
      toast.success(user.user?.message, successToast);
      navigate('/email-sent');
    }

    return () => {
      dispatch(userActions.clearErrors());
    };
  }, [user.loading, user.error, user.user?.message, navigate, dispatch]);

  return (
    <>
      <SpinnerLoader showSpinner={showSpinner} />
      <Container fluid>
        <div className='auth-box'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row className='mb-4'>
              <Col sm='12'>
                <div className='d-flex align-items-center justify-content-center mb-5'>
                  <img
                    className='medium-icon'
                    src={`${IMAGES_ASSESTS_PATH}/search.svg`}
                    alt='search'
                  />
                </div>
              </Col>
              <Col sm='12'>
                <h3 className='text-center mb-3'>Forgot your password?</h3>
              </Col>
              <Col sm='12'>
                <p className='text-center secondary-text-color mb-0'>
                  Enter the email associated with your account to <br /> change
                  your password.
                </p>
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col sm='12'>
                <label className='mb-2 d-block'>
                  Email <span className='required-color'>*</span>
                </label>
                <input
                  placeholder='Enter your email'
                  className={`form-input w-100 ${
                    errors['email'] && 'invalid-input'
                  }`}
                  type='email'
                  {...register('email', { required: true })}
                />
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col sm='12'>
                <Button type='submit' className='primary-btn w-100'>
                  Send Link
                </Button>
              </Col>
            </Row>

            <Row>
              <Col sm='12'>
                <div className='text-center'>
                  <u>
                    <Link className='primary-color' to={`/login`}>
                      Back to Login
                    </Link>
                  </u>
                </div>
              </Col>
            </Row>
          </form>
        </div>
      </Container>
    </>
  );
}

export default ForgotPassword;
